// extracted by mini-css-extract-plugin
export var carrierIcon = "_x9-0";
export var carrierLogo = "_x9-1";
export var detailsSection = "_x9-2";